import AuthManager from "../../../../common/auth/Manager";
import axios from "axios";

const isAuthorized = async (to, from, next) => {

  try {
    let id = to && to.params && to.params.protocolId
      ? parseInt(to.params.protocolId)
      : null;

    let response = await axios.get('/protocols/assigned/' + id +'/access');
    let {data: result} = response.data;

    if (!AuthManager.isGuest()  && (result && result.access)) {
      next()
    } else {
      next({name: 'login'})
    }
  } catch (e) {
    next({name: 'client'})
  }

};

export default isAuthorized;




// WEBPACK FOOTER //
// ./src/modules/dashboardParent/routes/hooks/canViewAssignedProtocol.js